import { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { setSearchBlockCompact, setShowSearch } from '../../store/appConfigsSlice'

import { useNavigate, useParams } from 'react-router-dom'
import { SeoTags } from '../../components'
import {
  PartnersInfoComponent
} from '../../components/info/PartnersComponent/PartnersInfoComponent'

const PartnersInfoPage = () => {
  const { airline } = useParams();
  const navigate = useNavigate()
  
  const [airlineData, setAirlineData] = useState(null);

  const dispatch = useDispatch();
  
  useEffect(() => {
    const getAirlineData = async () => {
      const airlineData = await import(`../../info/airlinesInfoJsons/${airline}.json`);
      
      if (!!airlineData?.default) {
        setAirlineData((airlineData?.default))
      }else {
        navigate('/')
      }
    }
    
    if (airline) {
      getAirlineData()
    }
  }, [airline])

  useEffect(() => {
    dispatch(setShowSearch(true))
    dispatch(setSearchBlockCompact(true));
  }, []);

  return (
    <>
      <SeoTags pageKey={airlineData?.pageKey} />
      <PartnersInfoComponent />
    </>
  );
};

export default withTranslation()(PartnersInfoPage);
